import { DesignState } from 'editor/src/store/design/types';

const markDesignDataAsTouchedReducer = (state: DesignState) => {
  state.designDataTouched = true;
};

export default markDesignDataAsTouchedReducer;
